import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMix14: IAbstractModule = {
    type: IModuleType.mixZ14,
    name: 'Z Mix 14 (9-14, 1-8)',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "9",
                cell_size_id: 1,
                accessible: false,
            },
            {
                name: "2",
                connector: "10",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "3",
                connector: "11",
                cell_size_id: 2,
                accessible: false,
            },
            {
                name: "4",
                connector: "12",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "5",
                connector: "13",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "6",
                connector: "14",
                cell_size_id: 4,
                accessible: false,
            },
        ],
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 1,
                accessible: false,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "3",
                connector: "3",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "4",
                connector: "4",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "5",
                connector: "5",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "6",
                connector: "6",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "7",
                connector: "7",
                cell_size_id: 3,
                accessible: false,
            },
            {
                name: "8",
                connector: "8",
                cell_size_id: 4,
                accessible: false,
            },
        ],
    ]
};
